angular.module(["ng"]).run(["$templateCache", function (c) {
    c.put("session-ended-tooltip-template.html", "<div class=\"ss-ended-tooltip-wrap\" ng-init=\"d.rating=null;d.feedback=''\"> {{'Screenshare session has ended. How would you rate it?'|translate}} <div class=\"rating-wrap\" ng-if=\"!d.rating\"> <rating-widget rating=\"d.rating\"></rating-widget> </div> <div class=\"com-wrap\" ng-if=\"d.rating\"> <textarea class=\"form-control\" rows=\"2\" ng-model=\"d.feedback\" placeholder=\"{{'Your feedback'|translate}}\"></textarea> <div class=\"text-right\"> <button class=\"btn btn-xs btn-primary\" ng-click=\"sendFeedback(d.rating, d.feedback);removeToast()\">{{'Send'|translate}}</button> </div> </div> </div>");
}]);


/*****************
 ** WEBPACK FOOTER
 ** ./app/modules/view-screenshare/session-ended-tooltip-template.html
 ** module id = 391
 ** module chunks = 0
 **/